import React, { useState } from 'react';
import { KeyRound, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { authErrorMessage } from '../lib/auth-errors';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const PasswordSetupPrompt = ({ email, onBack }) => {
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const send = async () => {
    setBusy(true); setError('');
    try {
      const response = await fetch(`${BASE}/api/auth/request-password-reset`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(authErrorMessage(data.detail, 'Unable to request the setup link.'));
      setSent(true);
    } catch (e) { setError(e.message || 'Connection error. Please try again.'); }
    finally { setBusy(false); }
  };
  return <div className="text-center" data-testid="password-setup-prompt">
    <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4"><KeyRound className="text-navy" size={32} /></div>
    <h2 className="text-base md:text-lg font-bold text-navy mb-3" data-testid="password-setup-title">{sent ? 'Check your email' : 'Set up your password'}</h2>
    <p className="text-navy/70 text-sm mb-5 break-words" data-testid="password-setup-message">{sent ? 'A password setup link has been requested. It expires in 30 minutes.' : 'Your account does not have a password yet. Request a secure setup link to your campaign email.'}</p>
    <p className="text-navy/60 text-sm break-all mb-5" data-testid="password-setup-email">{email}</p>
    {error && <p role="alert" className="text-red-600 text-sm mb-4" data-testid="password-setup-error">{error}</p>}
    <Button type="button" onClick={send} disabled={busy || sent} className="w-full h-auto py-3 bg-navy text-cream hover:bg-navy-dark rounded-xl" data-testid="password-setup-send"><Mail size={18} />{busy ? 'Requesting…' : sent ? 'Link requested' : 'Send setup link'}</Button>
    <button type="button" onClick={onBack} disabled={busy} className="text-navy/60 text-sm hover:text-navy mt-4 transition-colors" data-testid="password-setup-back">Back to login</button>
  </div>;
};